import Blurhash from "@components/blurhash";
import { cn } from "@lib/cn";
import { useIsPdf } from "@library/components";
import { useState } from "react";
import { getBlurhashFromUrl } from "@/shared";
import type { ICarouselItemBgImageData } from "../../types";

interface IProps {
  data: ICarouselItemBgImageData;
  isVisible: boolean;
}

export const CarouselBgImage = ({ data, isVisible }: IProps) => {
  const isPdf = useIsPdf();
  const {
    carouselBgImageAlt,
    carouselBgImageBlackAndWhite,
    carouselBgImageOverlay,
    carouselBgImageOverlayColor,
    carouselBgImageOverlayOpacity,
    carouselBgImageSrc,
  } = data;
  const [isLoaded, setIsLoaded] = useState(false);
  const hash = getBlurhashFromUrl(carouselBgImageSrc);

  return (
    <div
      className={cn({
        "swiper-slide": !isPdf,
        "tw-absolute tw-left-0 tw-top-0 tw-z-0 tw-size-full": isPdf,
      })}
    >
      {carouselBgImageSrc && (
        <>
          {carouselBgImageOverlay && (
            <div
              className="tw-absolute tw-left-0 tw-top-0 tw-z-10 tw-size-full"
              style={{
                backgroundColor: carouselBgImageOverlayColor,
                opacity: (carouselBgImageOverlayOpacity ?? 0) / 100,
              }}
            />
          )}
          {isVisible && (
            <img
              className={cn({
                "tw-grayscale": !!carouselBgImageBlackAndWhite,
                "tw-size-full tw-object-cover": true,
              })}
              src={carouselBgImageSrc}
              alt={carouselBgImageAlt}
              onLoad={() => setIsLoaded(true)}
            />
          )}
          {hash && !isLoaded && <Blurhash blurhash={hash} />}
        </>
      )}
    </div>
  );
};
